import Form from "../modules/form.js";

const templateEnquiry = {
  init() {
    new Form("#contact-form");
    this.formTypeSwitch();
  },

  /**
   * Form Field Switch Private-Business
   */
  formTypeSwitch() {
    $(".cform__top-btn").on("click", function () {
      var isPrivate = $(this).hasClass("private");

      // Toggle active class on buttons
      $(".cform__top-btn")
        .removeClass("active")
        .filter(this)
        .addClass("active");

      // Toggle form classes
      $("#contact-form, #service-form")
        .removeClass("business private")
        .addClass(isPrivate ? "private" : "business");

      // Set hidden input value
      $("input#contact-type").val(isPrivate ? "private" : "legal");

      // Correctly toggle "disabled" class on input fields based on type
      $(".privateInput input").toggleClass("disabled", !isPrivate); // Enable if private, disable if not
      $(".businessInput input").toggleClass("disabled", isPrivate); // Disable if private, enable if not
    });
  },
};
export default templateEnquiry;
